import { useEffect, useState } from 'react';

import { Button } from '../button';
import { Checkbox } from '../checkbox';
import { Input } from '../input';
import { Modal } from '../modal';

export type LinkModalValue = {
  url: string;
  text: string;
  tooltip: string;
  openInNewTab: boolean;
};

type LinkModalProps = {
  isOpen: boolean;
  initialValue: LinkModalValue;
  onClose: () => void;
  onSubmit: (value: LinkModalValue) => void;
};

export const LinkModal = ({ isOpen, initialValue, onClose, onSubmit }: LinkModalProps) => {
  const [value, setValue] = useState<LinkModalValue>(initialValue);

  useEffect(() => {
    if (isOpen) setValue(initialValue);
  }, [isOpen, initialValue]);

  const handleSubmit = () => {
    if (!value.url.trim()) return;
    onSubmit(value);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      title="Добавить ссылку"
      footer={
        <>
          <Button size="md" variant="neutral" className="flex-1" onClick={onClose}>
            Отмена
          </Button>
          <Button size="md" className="flex-1" onClick={handleSubmit} disabled={!value.url.trim()}>
            Добавить
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <Input
          autoFocus
          size="md"
          label="URL"
          placeholder="https://"
          value={value.url}
          onChange={(e) => setValue((v) => ({ ...v, url: e.target.value }))}
        />
        <Input
          size="md"
          label="Текст ссылки"
          placeholder="Отображаемый текст"
          value={value.text}
          onChange={(e) => setValue((v) => ({ ...v, text: e.target.value }))}
        />
        <Input
          size="md"
          label="Подсказка"
          placeholder="Текст всплывающей подсказки"
          value={value.tooltip}
          onChange={(e) => setValue((v) => ({ ...v, tooltip: e.target.value }))}
        />
        <Checkbox
          checked={value.openInNewTab}
          onChange={(e) => setValue((v) => ({ ...v, openInNewTab: e.target.checked }))}
          label="Открывать ссылку в новом окне"
        />
      </div>
    </Modal>
  );
};
